<template>
	<div class="manage-nfl-weekly-pickem-page">
		<div class="manage-nfl-weekly-pickem-page__content">
			<div class="pool-data" v-if="pool != null">
				<h3 class="header">Pool Settings</h3>
				<section class="info-to-join">
					<div class="info-to-join__header">
						<h4 class="section-header">Info to Join</h4>
						<i class="material-icons" @click="showCodeInfo = true">info</i>
					</div>
					<div class="info-to-join__group">
						<div class="row-info">
							<p class="row-label">Identifier</p>
							<p class="row-data">{{ pool.identifier }}</p>
						</div>
						<button class="row-action" type="button" v-clipboard:copy="pool.identifier" v-clipboard:success="onCopy">Copy to Clipboard</button>
					</div>
					<div class="info-to-join__group">
						<div class="row-info">
							<p class="row-label">Code to Join</p>
							<p class="row-data">{{ pool.join_code }}</p>
						</div>
						<button class="row-action" type="button" v-clipboard:copy="pool.join_code" v-clipboard:success="onCopy">Copy to Clipboard</button>
					</div>
				</section>

				<section class="settings">
					<div class="settings__header">
						<h4 class="section-header">General Settings</h4>
					</div>
					<div class="settings__group">
						<div class="row-info">
							<p class="row-label">Pool Name</p>
							<p class="row-data" v-if="!showEditName">{{ pool.name }}</p>
							<div class="edit row-data" v-else>
								<form @submit.prevent="saveName">
									<div class="form-group pool-edit">
										<input type="text" class="pool-edit__input" v-model="name" required>
									</div>
									<input type="submit" class="save-button" value="Save">
									<button class="cancel-button" @click.prevent="toggleEditName">Cancel</button>
								</form>
							</div>
						</div>
						<button class="row-action" @click.prevent="toggleEditName" v-if="!showEditName">Edit</button>
					</div>
				</section>

				<section class="actions">
					<div class="actions__header">
						<h4 class="section-header">Pool Actions</h4>
					</div>
					<div class="actions__group">
						<button class="delete-button" @click="showDeleteWarning = true">Delete Pool</button>
					</div>
				</section>
			</div>
		</div>

		<div class="popup" v-if="showDeleteWarning">
			<div class="popup__content">
				<p>Are you sure you want to delete? This action cannot be undone.</p>
				<button class="font-size--medium continue-saving" @click="deletePool">Continue</button>
				<button class="font-size--medium go-back" @click="showDeleteWarning = false">Go Back</button>
			</div>
		</div>

		<div class="popup" v-if="showCopySuccessful">
			<div class="popup__content">
				<p class="font-size--medium">Code Copied Successfully!</p>
				<div class="popup__content--bottom">
					<button class="font-size--medium text-color--secondary" @click="showCopySuccessful = false">Close</button>
				</div>	
			</div>
		</div>

		<div class="popup" v-if="showCodeInfo">
			<div class="popup__content">
				<p>Simply send both the pool identifier and code to any person you want to invite to the pool. They'll be able to use that information to join. No need to collect emails from everyone!</p>
				<div class="popup__content--bottom">
					<button class="font-size--medium text-color--secondary" @click="showCodeInfo = false">Close</button>
				</div>	
			</div>
		</div>
	</div>
</template>

<script>
	import axios from '@/axios'
	import { mapGetters, mapMutations, mapActions } from 'vuex'

	export default {
		props: [ 'poolId' ],
		data() {
			return {
				pool: null,
				showEditName: false,
				name: '',
				showDeleteWarning: false,
				showCopySuccessful: false,
				showCodeInfo: false,
			}
		},
		computed: {
			...mapGetters([
				'authenticated'
			])
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			...mapActions([
				'getCurrentPools',
				'attemptRefresh'
			]),
			onCopy() {
				this.showCopySuccessful = true
			},
			toggleEditName() {
				if(this.showEditName == true) {
					this.name = this.pool.name
					this.showEditName = false
				} else {
					this.showEditNumberOfBrackets = false
					this.showEditName = true
				}
			},
			saveName() {
				this.HTTP_IN_PROGRESS()
				axios.patch('nfl-weekly-pickems/' + this.pool.id, { name: this.name })
					.then(response => {
						this.pool = response.data.data
						this.name = this.pool.name
						this.toggleEditName()
						this.HTTP_FINISHED()
					})
			},
			deletePool() {
				this.showDeleteWarning = false
				this.HTTP_IN_PROGRESS()
				axios.delete('nfl-weekly-pickems/' + this.pool.id).then(() => {
					this.getCurrentPools().then(() => {
						this.HTTP_FINISHED()
						this.$router.replace({ name:  'home'})
					})
				})
			},
			getChallenge() {
				return axios.get('nfl-weekly-pickems/' + this.poolId)
			}
		},
		created() {
			if(this.authenticated) {
				this.HTTP_IN_PROGRESS()
				this.getChallenge().then(response => {
						this.pool = response.data.data
						this.name = this.pool.name
						this.HTTP_FINISHED()
					}).catch(() => {
						this.HTTP_FINISHED()
						this.$router.replace('/')
					})
			}
		}
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/nfl/nfl-weekly-pickem/manage';
</style>